module.exports = __webpack_public_path__ + "static/sundbyberg-adf1c09f9e39bf3c31933666470818ec.png";